export const trackMemberAreaClick = (source) => {
  if (typeof window !== "undefined" && window.posthog) {
    window.posthog.capture("clicked_member_area", { source });
  }
};
